import { useMemo } from "react";
import { SiteSyncState } from "@libs/api/gateways/sia/models/SiteSyncState";
import { getSequenceNumberSyncStates } from "./sequenc-number-sync-states.utils";

export const useSequenceNumberSyncStates = (state: SiteSyncState) => {
  return useMemo(() => getSequenceNumberSyncStates(state), [state]);
};
